import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';

const state = {
    id: 0,
    nombre: '',
    inactivo: false,
    rowVersion: null,
    
    retencionTipoDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_RETENCION_TIPO'(state, retencionTipoId) {
        state.id = retencionTipoId;
        state.nombre = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_RETENCION_TIPO'(state, retencionTipo) {
        state.nombre = retencionTipo.nombre.trim();
        state.inactivo = retencionTipo.inactivo;
        state.rowVersion = retencionTipo.rowVersion;
    },

    'INICIALIZAR_RETENCION_TIPO_DATOS' (state) {
        state.retencionTipoDatos = [];
    },
    'SET_RETENCION_TIPO_DATOS' (state, params) {
        state.retencionTipoDatos = params.retencionTipoDatos;
    }
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, retencionTipoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RETENCION_TIPO', retencionTipoId);

            if (retencionTipoId != 0) {
                apiAxios.get('retencionestipos/' + retencionTipoId + '/abm' ) 
                    .then(res => {
                        commit('SET_RETENCION_TIPO', res.data);
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    })
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let retencionTipo = {
                nombre: state.nombre.toUpperCase().trim(), 
                inactivo: state.inactivo,
            }

            let url = 'retencionestipos';
            if (state.id != 0) {
                retencionTipo.rowVersion = state.rowVersion;
                url += '/' + state.id;
            }

            apiAxios.post(url, retencionTipo)
                .then(() => {
                    resolve();
                })
                .catch( error => {
                    var appError = false
                    var errorMessage = ''
                    if (error.response.status == 500) {
                        if (error.response.headers['application-error']) {
                            errorMessage = error.response.data
                        }
                    }
                    if (!appError) {
                        errorMessage = error.response.data
                    }          
                    reject(errorMessage)
                })
        })
    },

    getRetencionTipoDatos ( { commit }, retencionTipoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RETENCION_TIPO_DATOS');

            if (retencionTipoId != 0) {
                apiAxios.get('retencionestipos/' + retencionTipoId ) 
                .then(res => {
                    let retencionTipoDatos = [
                        { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                        { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                        { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': res.data.inactivo ? 'Si' : 'No', 'formato': '' },
                    ];
                    
                    let params = {
                        retencionTipoDatos 
                    }
                    commit('SET_RETENCION_TIPO_DATOS', params);

                    resolve();
                })
                .catch(error => reject(error))
            } else {
                resolve();
            }
            
        }, error => {
            reject(error);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}